import React, {
  forwardRef,
  useRef,
  useImperativeHandle,
  useEffect,
} from 'react';
import { Button } from '@mui/material';
import { Editor as TinyEditor } from '@tinymce/tinymce-react';
import { TINYMCE_API_KEY } from '../../config/environment';

const Editor = forwardRef(({ defaultValue = '', readOnly = false }, ref) => {
  const editorRef = useRef(null);

  useImperativeHandle(ref, () => ({
    getHTML: () => editorRef.current?.getContent() || '',
    setHTML: html => editorRef.current?.setContent(html),
    pasteHTML: html => editorRef.current?.insertContent(html),
    getContents: () => editorRef.current?.getContent({ format: 'raw' }) || '',
  }));

  useEffect(() => {
    if (editorRef.current && defaultValue) {
      editorRef.current.setContent(defaultValue);
    }
  }, [defaultValue]);

  const handlePaste = async () => {
    if (!editorRef.current || !navigator.clipboard) return;
    try {
      const text = await navigator.clipboard.readText();
      editorRef.current.insertContent(text);
    } catch (err) {
      console.error('Failed to read clipboard', err);
    }
  };

  return (
    <div>
      <TinyEditor
        apiKey={TINYMCE_API_KEY}
        onInit={(evt, editor) => (editorRef.current = editor)}
        initialValue={defaultValue}
        init={{
          height: 300,
          menubar: false,
          readonly: readOnly,
          plugins: [
            'link',
            'image',
            'lists',
            'table',
            'paste',
            'code'
          ],
          toolbar:
            'undo redo | formatselect | ' +
            'bold italic underline strikethrough | ' +
            'alignleft aligncenter alignright alignjustify | ' +
            'bullist numlist outdent indent | ' +
            'link image table | code',
          image_advtab: true,
          image_caption: true,
          image_toolbar:
            'alignleft aligncenter alignright alignjustify | ' +
            'imageoptions deleteimage',
          style_formats: [
            {
              title: 'Center Image',
              selector: 'img',
              styles: { display: 'block', margin: '0 auto' }
            }
          ]
        }}
      />
      {!readOnly && (
        <Button size="small" onClick={handlePaste} sx={{ mt: 1 }}>
          Paste HTML from Clipboard
        </Button>
      )}
    </div>
  );
});

export default Editor;
